import { useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { IForm } from '@entities/AdminConversationCategory/model/types';
import { errorHandleMiddleware } from '@entities/attachment/lib';
import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { IModalForm } from '@features/AdminConversationCategoryUpsertModal/model/types';
import { generateId } from '@shared/helpers';

export const useFormHandler = (formData: IForm) => {
    const { t } = useTranslation();

    const [form, setForm] = useState<IModalForm>({
        title: '',
        attachment: [],
        link: '',
        description: '',
        history: true,
        comment: '',
        primaryLink: '',
        primaryText: '',
        secondaryLink: '',
        secondaryText: '',
    });

    useEffect(() => {
        if (formData) {
            const buttons = formData.actions.filter((action) => action.type !== 'close');

            const updatedForm: IModalForm = {
                ...form,
                title: formData.title,
                attachment: formData.image ? [formData.image] : [],
                description: formData.description,
                comment: formData.privateDescription,
                primaryText: buttons[0] ? buttons[0].text : '',
                primaryLink: buttons[0] ? buttons[0]?.url : '',
                secondaryText: buttons[1] ? buttons[1]?.text : '',
                secondaryLink: buttons[1] ? buttons[1]?.url : '',
                link: formData.surveyUrl,
            };
            setForm(updatedForm);
        }
    }, [formData]);

    const fileInputRef = useRef<HTMLInputElement>(null);
    const onClickInputRef = () => {
        fileInputRef.current?.click();
    };

    const onInputChange = (name: string, value: string) => {
        setForm((prevState) => ({ ...prevState, [name]: value }));
    };
    const onTextEditorChange = (value: string) => {
        setForm((prevState) => ({ ...prevState, description: value }));
    };
    const onAddFiles = async (files: File[]) => {
        const newAttachment: TAttachmentOnClient[] = files.map((file) => ({
            id: generateId(true) as number,
            file,
            isLoading: true,
        }));

        setForm((prevState) => ({ ...prevState, attachment: newAttachment }));
    };

    const uploadFilesHandler = errorHandleMiddleware({
        onAddFiles,
        t,
        maxAttachmentSizeInMb: 1000,
        maxOverallSizeInMb: 10000,
        isMultiple: false,
        validateExtensions: ['png', 'jpeg', 'gif', 'jpg', 'heic', 'webp'],
    });
    return {
        fileInputRef,
        onClickInputRef,
        form,
        onInputChange,
        uploadFilesHandler,
        onTextEditorChange,
    };
};
